/*
|   this hook is to allow multiple instances of react-dnd to work
|   by avoiding multiple instances of DND-backends, which causes errors
|   --- wrap around elements that need drag-and-drop,
|       just like typical <DnDProvider/> usage
|
|   source: https://github.com/react-dnd/react-dnd/issues/186#issuecomment-561631584
*/

import { DndProvider, createDndContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import React, { useRef } from 'react';

// Creating the backend as context allows multiple components usage
// --I think?
const contextRef = createDndContext(HTML5Backend);

// ensure {children} exist:
const DNDProviderElement = (props) => {
  const manager = useRef(contextRef);
  if (!props.children) return null;
  return (
    <DndProvider manager={manager.current.dragDropManager}>
      {props.children}
    </DndProvider>
  );
};

const DragAndDrop = (props) => (
  <React.Fragment>{DNDProviderElement(props)}</React.Fragment>
);

export default DragAndDrop;



// WEBPACK FOOTER //
// ./src/components/util/DragAndDrop.jsx